<template>
  <v-dialog v-model="dialogOpen" persistent max-width="450">
    <v-card>
      <v-card-title>Installation Address</v-card-title>
      <v-card-text>
        <AddressForm :passedAddress="address"/>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" small @click.prevent="$emit('submit-dialog')" :disabled="installAddressEdit">Save</v-btn>
        <v-btn color="primary" small outlined class="ml-3" @click="$emit('close-dialog')">Cancel</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import AddressForm from "../Misc/AddressForm";
  export default {
    components: { AddressForm },
    props: [ 'address','dialogOpen','selectedAddress' ],
    computed: {
      installAddressEdit(){
        return Object.keys(this.selectedAddress).length===0;
      }
    },
  }
</script>

<style lang="scss" scoped></style>
